import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { PageBase, ExtendRentalOption, ProlongRentalResult, OpenHours, RentalInfo, TypeCategoryInfo, TimeSlot, DeviceType } from 't4core';
import * as moment from 'moment';
import { BookingService, NavigationService, TimeStep } from 'app-components';
import { ActiveRentalService } from 'app-components';
import { LayoutService } from 'app-components';
import { Moment } from 'moment';
import { AppIntegrationService } from 't4-app-integration';

@Component({
  selector: 'app-headlamps-info',
  templateUrl: './headlamps-info.html',
  styleUrls: ['./headlamps-info.css'],
  standalone: false
})
export class HeadLampsInfoComponent extends PageBase implements OnInit {

  public searching: boolean = false;
  public searchSucceeded: boolean = false;
  public checklistStep: number = 0;
  public booking: RentalInfo;

  private isDestroyed = false;
  private resolveDestroyed!: () => void;
  private destroyedPromise: Promise<void>;

  public searchProgress = 100;
  private progressTimer?: ReturnType<typeof setInterval>;

  public get isChecklistCompleted(): boolean {
    return this.checklistStep >= 3;
  }

  public get currentChecklistButtonLabel(): string {
    switch (this.checklistStep) {
      case 0:
        return 'Connected?';
      case 1:
        return 'Engine started?';
      default:
        return 'Headlight turned on?';
    }
  }

  constructor(
    elementRef: ElementRef,
    private navigationService: NavigationService,
    private rentalService: ActiveRentalService,
    private appService: AppIntegrationService
  ) {
    super(elementRef);

    this.destroyedPromise = new Promise<void>(resolve => {
      this.resolveDestroyed = resolve;
    });
  }

  async ngOnInit(): Promise<void> {
    this.booking = await this.rentalService.getBooking();
    
  }


  ngOnDestroy(): void {
    this.isDestroyed = true;
    this.resolveDestroyed();
    this.stopSearchProgress();
  }

  public async searchForConnection() {
    if (this.searching) {
      return;
    }

    this.searching = true;

    try {
      const lock = this.booking.RentalObject.Locks.find(
        x => x.DeviceType === DeviceType.Tracker
      );

      //Should never hit, but in case.
      // if (!lock) {
      //   console.log("No tracker lock found");
      //   this.searchSucceeded = true;
      //   this.goingToNext();
      //   return;
      // }

      const startedAt = Date.now();
      const timeoutMs = 30_000;
      const pollIntervalMs = 5_000;
      const maxAgeMs = 5 * 60 * 1000;

      this.startSearchProgress(45_000);

      while (!this.isDestroyed && Date.now() - startedAt < timeoutMs) {
        try {
          const result = await this.Api.get<any>('RentalObject/GetLastLockHistory', {
            lockId: lock.Id
          });

          if (this.isDestroyed) {
            return;
          }

          if (result?.TimeStamp) {
            const timestamp = new Date(result.TimeStamp).getTime();
            const isNewerThanFiveMinutes = Date.now() - timestamp <= maxAgeMs;

            if (isNewerThanFiveMinutes) {
              this.searchSucceeded = true;
              this.goingToNext();
              return;
            }
          }
        } catch (error) {
          if (this.isDestroyed) {
            return;
          }

        
        }

        await Promise.race([
          this.delay(pollIntervalMs),
          this.destroyedPromise
        ]);
      }

      if (this.isDestroyed) {
        return;
      }

      console.log('No recent update found within 30 seconds, continuing anyway');
      this.searchSucceeded = true;
      this.goingToNext();
    } finally {
      this.stopSearchProgress();

      if (!this.isDestroyed) {
        this.searching = false;
      }
    }
  }

  public advanceChecklist(): void {
    if (!this.isChecklistCompleted) {
      this.checklistStep++;
    }
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public goingToNext() {
    this.navigationService.executeCommand("Next");
  }

  private startSearchProgress(timeoutMs: number): void {
    const startedAt = Date.now();

    this.searchProgress = 100;

    this.progressTimer = setInterval(() => {
      const elapsed = Date.now() - startedAt;
      const remaining = Math.max(timeoutMs - elapsed, 0);

      this.searchProgress = (remaining / timeoutMs) * 100;

      if (remaining <= 0) {
        this.stopSearchProgress();
      }
    }, 100);
  }

  private stopSearchProgress(): void {
    if (this.progressTimer) {
      clearInterval(this.progressTimer);
      this.progressTimer = undefined;
    }
  }

}
